import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"red"} }, " Any Update Will Apply On App / WebSite Services Section ")
], -1)
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "symbol symbol-45px me-5 cursor-pointer" }
const _hoisted_9 = ["src", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_12 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_14 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeServicesAdvancedSearch = _resolveComponent("HomeServicesAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_HomeServicesAdvancedSearch, {
                onTypeSelected: _ctx.onFilterChange,
                onReset: _ctx.onResetFilters
              }, null, 8, ["onTypeSelected", "onReset"])
            ])
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-icon": _withCtx(({ row: homeService }) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    alt: "Pic",
                    src: homeService.icon,
                    onClick: _withModifiers(($event: any) => (_ctx.editHomeService(homeService.id)), ["prevent"])
                  }, null, 8, _hoisted_9)
                ])
              ])
            ]),
            "cell-titleEn": _withCtx(({ row: homeService }) => [
              _createTextVNode(_toDisplayString(homeService.titleEn), 1)
            ]),
            "cell-titleAr": _withCtx(({ row: homeService }) => [
              _createTextVNode(_toDisplayString(homeService.titleAr), 1)
            ]),
            "cell-version": _withCtx(({ row: homeService }) => [
              _createTextVNode(_toDisplayString(homeService.version), 1)
            ]),
            "cell-sort": _withCtx(({ row: homeService }) => [
              _createTextVNode(_toDisplayString(homeService.sort), 1)
            ]),
            "cell-isHome": _withCtx(({ row: homeService }) => [
              (homeService.isHome)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.translate('yes')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('no')), 1))
            ]),
            "cell-showWeb": _withCtx(({ row: homeService }) => [
              (homeService.showWeb)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.translate('yes')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.translate('no')), 1))
            ]),
            "cell-isActive": _withCtx(({ row: homeService }) => [
              (homeService.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: homeService }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editHomeService(homeService.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_16),
              (_ctx.can('remove', 'settings'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusHomeService(homeService)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                onClick: _withModifiers(($event: any) => (_ctx.editSeo(homeService.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen064.svg" })
                ])
              ], 8, _hoisted_20)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}